import { defineStore } from 'pinia';
import type { Cart } from '~/modules/GraphQL/types';
import { GenericObjectType } from '~/utils/types';

interface CustomerState {
  cart: Cart,
  zuoraCouponApplied: Boolean,
  isCouponCodeApplying: Boolean,
  zuoraCartDatas: GenericObjectType
}

export const useCartStore = defineStore('cart', {
  state: (): CustomerState => ({
    zuoraCartDatas: null,
    isCouponCodeApplying:false,
    zuoraCouponApplied: false,
    cart: {
      id: '', is_virtual: false, total_quantity: 0, shipping_addresses: [],
    },
  }),
});
